"use client";

import PropTypes from "prop-types";
import { useEffect } from "react";
import { CookieProvider } from "context/CookieContext";
import PlausibleProvider from "next-plausible";

import { PostHogProvider } from "posthog-js/react";
import { initPostHog, posthog } from "lib/posthog/init";

export default function Providers({ children, domain, phData }) {
  useEffect(() => {
    if (phData) {
      initPostHog();
    }
  }, [phData]);

  const content = (
    <PlausibleProvider domain={domain}>
      <CookieProvider>{children}</CookieProvider>
    </PlausibleProvider>
  );

  if (!phData) {
    return content;
  }

  return (
    <PostHogProvider client={posthog} bootstrapData={phData}>
      {content}
    </PostHogProvider>
  );
}

Providers.propTypes = {
  children: PropTypes.node.isRequired,
  domain: PropTypes.string.isRequired,
  phData: PropTypes.object,
};
